// Actions
const FETCH_FEEDS = 'zen/NarrativeFeeds/FETCH_FEEDS';
const FETCH_FEEDS_SUCCEEDED = 'zen/NarrativeFeeds/FETCH_FEEDS_SUCCEEDED';
const FETCH_FEEDS_FAILED = 'zen/NarrativeFeeds/FETCH_FEEDS_FAILED';

const FETCH_CAMPAIGN = 'zen/NarrativeFeeds/FETCH_CAMPAIGN';
const FETCH_CAMPAIGN_SUCCEEDED = 'zen/NarrativeFeeds/FETCH_CAMPAIGN_SUCCEEDED';
const FETCH_CAMPAIGN_FAILED = 'zen/NarrativeFeeds/FETCH_CAMPAIGN_FAILED';

const UPDATE_CAMPAIGN = 'zen/NarrativeFeeds/UPDATE_CAMPAIGN';
const UPDATE_CAMPAIGN_SUCCEEDED = 'zen/NarrativeFeeds/UPDATE_CAMPAIGN_SUCCEEDED';
const UPDATE_CAMPAIGN_FAILED = 'zen/NarrativeFeeds/UPDATE_CAMPAIGN_FAILED';

const CREATE_FEED = 'zen/NarrativeFeeds/CREATE_FEED';
const CREATE_FEED_SUCCEEDED = 'zen/NarrativeFeeds/CREATE_FEED_SUCCEEDED';
const CREATE_FEED_FAILED = 'zen/NarrativeFeeds/CREATE_FEED_FAILED';

const UPDATE_FEED = 'zen/NarrativeFeeds/UPDATE_FEED';
const UPDATE_FEED_SUCCEEDED = 'zen/NarrativeFeeds/UPDATE_FEED_SUCCEEDED';
const UPDATE_FEED_FAILED = 'zen/NarrativeFeeds/UPDATE_FEED_FAILED';

const DELETE_FEED = 'zen/NarrativeFeeds/DELETE_FEED';
const DELETE_FEED_SUCCEEDED = 'zen/NarrativeFeeds/DELETE_FEED_SUCCEEDED';
const DELETE_FEED_FAILED = 'zen/NarrativeFeeds/DELETE_FEED_FAILED';

const FETCH_CURATED_FEEDS = 'zen/NarrativeFeeds/FETCH_CURATED_FEEDS';
const FETCH_CURATED_FEEDS_SUCCEEDED = 'zen/NarrativeFeeds/FETCH_CURATED_FEEDS_SUCCEEDED';
const FETCH_CURATED_FEEDS_FAILED = 'zen/NarrativeFeeds/FETCH_CURATED_FEEDS_FAILED';

const SET_NEW_FEED_NAME = 'zen/NarrativeFeeds/SET_NEW_FEED_NAME';
const SET_BANNER = 'zen/NarrativeFeeds/SET_BANNER';
const UPDATE_FEED_PROFILES = 'zen/NarrativeFeeds/UPDATE_FEED_PROFILES';
const UPDATE_FEED_NAME = 'zen/NarrativeFeeds/UPDATE_FEED_NAME';
const SET_ENABLED_CURATED_FEEDS = 'zen/NarrativeFeeds/SET_ENABLED_CURATED_FEEDS';

export const initialState = {
  feeds: [],
  newFeedName: '',
  bannerMessage: '',
  bannerTitle: '',
  bannerType: '',
  fetchingFeeds: false,
  creatingFeed: false,
  updatingFeed: false,
  deletingFeed: false,
  curatedFeeds: [],
  enabledCuratedFeeds: [],
  fetchingCuratedFeeds: false,
  updatingCuratedFeeds: false,
  campaign: {},
  fetchingCampaign: false,
  updatingCampaign: false
};

// Reducer
// eslint-disable-next-line complexity
const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCH_FEEDS:
      return { ...state, fetchingFeeds: true };
    case FETCH_FEEDS_SUCCEEDED:
      return { ...state, feeds: action.payload, fetchingFeeds: false };
    case FETCH_FEEDS_FAILED:
      return { ...state, fetchingFeeds: false };

    case CREATE_FEED:
      return { ...state, creatingFeed: true };
    case CREATE_FEED_SUCCEEDED:
      return {
        ...state,
        feeds: [...state.feeds, action.payload],
        newFeedName: '',
        creatingFeed: false
      };
    case CREATE_FEED_FAILED:
      return { ...state, creatingFeed: false };

    case UPDATE_FEED:
      return { ...state, updatingFeed: true };
    case UPDATE_FEED_SUCCEEDED: {
      const updatedFeeds = state.feeds.map(feed => (feed.id === action.payload.id ? action.payload : feed));
      return { ...state, feeds: updatedFeeds, updatingFeed: false };
    }
    case UPDATE_FEED_FAILED:
      return { ...state, updatingFeed: false };

    case DELETE_FEED:
      return { ...state, deletingFeed: true };
    case DELETE_FEED_SUCCEEDED: {
      const filteredFeeds = state.feeds.filter(feed => feed.id !== action.payload);
      return { ...state, feeds: filteredFeeds, deletingFeed: false };
    }
    case DELETE_FEED_FAILED:
      return { ...state, deletingFeed: false };

    case FETCH_CURATED_FEEDS:
      return { ...state, fetchingCuratedFeeds: true };

    case FETCH_CURATED_FEEDS_SUCCEEDED: {
      const curatedFeeds = action.payload.map(feed => ({
        label: feed.name,
        value: feed.id
      }));

      const newState = {
        ...state,
        curatedFeeds,
        fetchingCuratedFeeds: false
      };

      if (state.campaign?.narrative_feeds) {
        newState.enabledCuratedFeeds = curatedFeeds.filter(feed =>
          state.campaign.narrative_feeds.some(f => f.feedId === feed.value)
        );
      }

      return newState;
    }
    case FETCH_CURATED_FEEDS_FAILED:
      return { ...state, fetchingCuratedFeeds: false };

    case SET_ENABLED_CURATED_FEEDS:
      return { ...state, enabledCuratedFeeds: action.payload };

    case FETCH_CAMPAIGN:
      return { ...state, fetchingCampaign: true };
    case FETCH_CAMPAIGN_SUCCEEDED: {
      const newState = {
        ...state,
        campaign: action.payload,
        fetchingCampaign: false
      };
      if (action.payload?.narrative_feeds && state.curatedFeeds.length > 0) {
        newState.enabledCuratedFeeds = state.curatedFeeds.filter(feed =>
          action.payload?.narrative_feeds.some(f => f.feedId === feed.value)
        );
      }

      return newState;
    }
    case FETCH_CAMPAIGN_FAILED:
      return { ...state, fetchingCampaign: false };
    case UPDATE_CAMPAIGN:
      return { ...state, updatingCampaign: true };
    case UPDATE_CAMPAIGN_SUCCEEDED:
      return {
        ...state,
        updatingCampaign: false,
        campaign: action.payload
      };
    case UPDATE_CAMPAIGN_FAILED:
      return { ...state, updatingCampaign: false };

    case SET_NEW_FEED_NAME:
      return { ...state, newFeedName: action.payload };

    case SET_BANNER:
      return {
        ...state,
        bannerMessage: action.payload.message,
        bannerTitle: action.payload.title,
        bannerType: action.payload.type
      };

    case UPDATE_FEED_PROFILES: {
      const { feedIndex, profiles, includeAll, name } = action.payload;
      const updatedFeeds = [...state.feeds];

      if (profiles !== undefined) {
        updatedFeeds[feedIndex].profile_ids = profiles;
      }
      if (includeAll !== undefined) {
        updatedFeeds[feedIndex].includeAll = includeAll;
      }
      if (name !== undefined) {
        updatedFeeds[feedIndex].name = name;
      }

      return { ...state, feeds: updatedFeeds };
    }

    case UPDATE_FEED_NAME: {
      const { feedIndex, name } = action.payload;
      const updatedFeeds = [...state.feeds];
      updatedFeeds[feedIndex].name = name;
      return { ...state, feeds: updatedFeeds };
    }

    default:
      return state;
  }
};

// Action Creators
const fetchFeeds = payload => {
  return { type: FETCH_FEEDS, payload };
};

const fetchFeedsSucceeded = payload => {
  return { type: FETCH_FEEDS_SUCCEEDED, payload };
};

const fetchFeedsFailed = () => {
  return { type: FETCH_FEEDS_FAILED };
};

const createFeed = payload => {
  return { type: CREATE_FEED, payload };
};

const createFeedSucceeded = payload => {
  return { type: CREATE_FEED_SUCCEEDED, payload };
};

const createFeedFailed = () => {
  return { type: CREATE_FEED_FAILED };
};

const updateFeed = payload => {
  return { type: UPDATE_FEED, payload };
};

const updateFeedSucceeded = payload => {
  return { type: UPDATE_FEED_SUCCEEDED, payload };
};

const updateFeedFailed = () => {
  return { type: UPDATE_FEED_FAILED };
};

const deleteFeed = payload => {
  return { type: DELETE_FEED, payload };
};

const deleteFeedSucceeded = payload => {
  return { type: DELETE_FEED_SUCCEEDED, payload };
};

const deleteFeedFailed = () => {
  return { type: DELETE_FEED_FAILED };
};

const setNewFeedName = payload => {
  return { type: SET_NEW_FEED_NAME, payload };
};

const setBanner = payload => {
  return { type: SET_BANNER, payload };
};

const updateFeedProfiles = payload => {
  return { type: UPDATE_FEED_PROFILES, payload };
};

const updateFeedName = payload => {
  return { type: UPDATE_FEED_NAME, payload };
};

// Action Creators for curated feeds
const fetchCuratedFeeds = payload => {
  return { type: FETCH_CURATED_FEEDS, payload };
};

const fetchCuratedFeedsSucceeded = payload => {
  return { type: FETCH_CURATED_FEEDS_SUCCEEDED, payload };
};

const fetchCuratedFeedsFailed = () => {
  return { type: FETCH_CURATED_FEEDS_FAILED };
};

const setEnabledCuratedFeeds = payload => {
  return { type: SET_ENABLED_CURATED_FEEDS, payload };
};

const fetchCampaign = payload => {
  return { type: FETCH_CAMPAIGN, payload };
};

const fetchCampaignSucceeded = payload => {
  return { type: FETCH_CAMPAIGN_SUCCEEDED, payload };
};

const fetchCampaignFailed = () => {
  return { type: FETCH_CAMPAIGN_FAILED };
};

const updateCampaign = payload => {
  return { type: UPDATE_CAMPAIGN, payload };
};

const updateCampaignSucceeded = payload => {
  return { type: UPDATE_CAMPAIGN_SUCCEEDED, payload };
};

const updateCampaignFailed = () => {
  return { type: UPDATE_CAMPAIGN_FAILED };
};

export default reducer;
export {
  // Actions
  FETCH_FEEDS,
  FETCH_FEEDS_SUCCEEDED,
  FETCH_FEEDS_FAILED,
  CREATE_FEED,
  CREATE_FEED_SUCCEEDED,
  CREATE_FEED_FAILED,
  UPDATE_FEED,
  UPDATE_FEED_SUCCEEDED,
  UPDATE_FEED_FAILED,
  DELETE_FEED,
  DELETE_FEED_SUCCEEDED,
  DELETE_FEED_FAILED,
  FETCH_CURATED_FEEDS,
  FETCH_CURATED_FEEDS_SUCCEEDED,
  FETCH_CURATED_FEEDS_FAILED,
  SET_NEW_FEED_NAME,
  SET_BANNER,
  UPDATE_FEED_PROFILES,
  UPDATE_FEED_NAME,
  SET_ENABLED_CURATED_FEEDS,
  FETCH_CAMPAIGN,
  FETCH_CAMPAIGN_SUCCEEDED,
  FETCH_CAMPAIGN_FAILED,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCEEDED,
  UPDATE_CAMPAIGN_FAILED,
  // Action Creators
  fetchFeeds,
  fetchFeedsSucceeded,
  fetchFeedsFailed,
  createFeed,
  createFeedSucceeded,
  createFeedFailed,
  updateFeed,
  updateFeedSucceeded,
  updateFeedFailed,
  deleteFeed,
  deleteFeedSucceeded,
  deleteFeedFailed,
  fetchCuratedFeeds,
  fetchCuratedFeedsSucceeded,
  fetchCuratedFeedsFailed,
  setNewFeedName,
  setBanner,
  updateFeedProfiles,
  updateFeedName,
  setEnabledCuratedFeeds,
  fetchCampaign,
  fetchCampaignSucceeded,
  fetchCampaignFailed,
  updateCampaign,
  updateCampaignSucceeded,
  updateCampaignFailed
};
